import http from "@/services/http";

export async function getOktaProfile(email: string) {
  const { data } = await http().get(
    window.env.API_PERMISSION + "/user-profile/validate/" + email
  );
  return data;
}
